import 'jquery';
import 'jquery-ujs';
import 'angular';
import 'jquery-ui/ui/widgets/sortable';
import 'jquery-ui/ui/widgets/draggable';
import 'angular-ui-sortable';
import 'vendor/angular-ui/bootstrap';
import 'vendor/ng-table';
import 'vendor/angular-flash';
import 'vendor/angular-signature';
import 'vendor/angular-ui/bootstrap/dropdown';
import 'vendor/angular-ui/bootstrap/dropdownSelect';
import 'ng-rollbar';
import 'angular-ui-router';
import 'angular-scroll';
import 'components-jquery-htmlclean';
import 'angular-file-model';
import 'restangular';
import 'ng-tags-input';
import 'angular-clipboard';
import 'angular-bootstrap-colorpicker';
import 'timepicker';
import 'angular-jquery-timepicker';
import 'ng-mask';
import 'ng-infinite-scroll';
import 'ngreact';
import 'ngmap';

import 'vendor/jquery.ui.touch-punch.js';
import 'vendor/text-angular.js';
import 'vendor/text-angular-sanitize.min.js';
import 'vendor/fullcalendar.js';
import 'vendor/angular-ui/calendar.js';
import 'vendor/ezidebit_2_0_0.min.js';

const requireAll = (requireContext) => {
  requireContext.keys().map((item) => requireContext(item));
};
requireAll(require.context('modules/gym', true));
requireAll(require.context('modules/shared', true));
requireAll(require.context('modules/filters', true));
requireAll(require.context('modules/components', true));
requireAll(require.context('@react/entry_points', true));
requireAll(require.context('templates', true, /\.(html|slim)$/));

import 'modules/model.js';
import 'modules/gym.js';
import 'modules/form-library.js';
import 'modules/http_interceptors.js';
import 'modules/shared/_shared.js.coffee';
import 'modules/on_demand/actionCable.js';
import 'modules/on_demand/tasks_service.js.coffee';
import 'modules/on_demand/page_settings_service.js.coffee';
import 'modules/on_demand/employment_service.js.coffee';
